export const NAME = 'name';
export const ADDRESS = 'address';
export const COMPANY = 'company';
export const DOCUMENT_DATE = 'document_date';
export const ACCOUNT_NUMBER = 'account_number';
export const BEGINNING_BALANCE = 'beginning_balance';
export const ENDING_BALANCE = 'ending_balance';
export const CURRENCY = 'currency';
export const DATE_OF_BIRTH = 'date_of_birth';
export const EXPIRY_DATE = 'expiry_date';
export const EIN = 'ein';
export const SSN = 'ssn';
